export const actions = {
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE',
};

export function openModal(name, options = {}, props = {}) {
  return dispatch => dispatch({
    type: actions.MODAL_OPEN,
    payload: {
      name,
      options,
      props,
    },
  });
}

export function closeModal() {
  return dispatch => dispatch({
    type: actions.MODAL_CLOSE,
  });
}
